import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRbacStore } from '../store/rbacStore';

/**
 * Top-level hub (module) access guard.
 *
 * Keeps a user out of a hub they are not granted — whether they clicked a
 * launcher tile or typed the URL. Blocked users are sent to the Dashboard
 * (always accessible) rather than a dead-end 401.
 *
 * Fails SAFE, not open: Super Admin always passes; an empty hub list (unknown,
 * fetch failed, or an older backend) allows only People — the single published
 * hub — so a transient error never exposes an unpublished module nor hides the
 * one live one.
 */
export function RequireHubRoute({
  hubKey,
  children,
}: {
  hubKey: string;
  children: React.ReactNode;
}) {
  const hubs = useRbacStore((s) => s.hubs);
  const roles = useRbacStore((s) => s.roles);

  const allowed =
    roles.includes('Super Admin') ||
    (hubs.length === 0 ? hubKey === 'people' : hubs.includes(hubKey));

  if (allowed) return <>{children}</>;
  return <Navigate to="/dashboard" replace />;
}
